import { render } from "./Glifo.vue?vue&type=template&id=184d987a"
import script from "./Glifo.vue?vue&type=script&lang=js"
export * from "./Glifo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__